import { translate } from '@/util/translate';
import Board from '@/views/Board';
import AppointmentList from '@/views/AppointmentList';
import ServiceProviderUsersList from '@/views/serviceProvider/components/ServiceProviderUsersList';
import ServiceProviderClientsList from '@/views/serviceProvider/components/ServiceProviderClientsList';
import Reports from '../../views/Reports.vue';
import RealtyList from '@/views/RealtyList'
import DisputeList from '@/views/dispute/DisputeList'

let serviceRoute = [
  {
    path: '/board',
    name: 'serviceProviderBoard',
    component: Board,
    meta: {
      login: true,
      title: translate['pages.title.board'],
      icon: 'mdi-file-cabinet',
      roles: ['ROLE_SERVICE_PROVIDER'],
    }
  },

  {
    path: '/appointments',
    name: 'serviceProviderAppointments',
    component: AppointmentList,
    meta: {
      login: true,
      title: translate['pages.title.appointmentList'],
      icon: 'mdi-calendar-month-outline',
      roles: ['ROLE_SERVICE_PROVIDER'],
    },
  },

  {
    path: '/disputes',
    name: 'serviceProviderDisputes',
    component: DisputeList,
    meta: {
      login: true,
      title: translate['pages.title.disputeList'],
      icon: 'mdi-text-box-search-outline',
      roles: ['ROLE_SERVICE_PROVIDER'],
    },
  },

  {
    path: '/reports',
    name: 'serviceProviderReports',
    component: Reports,
    meta: {
      login: true,
      title: translate['pages.title.reports'],
      icon: 'mdi-file-chart-outline',
      roles: ['ROLE_SERVICE_PROVIDER'],
    },
  },

  {
    path: '/service-provider-users',
    name: 'service-provider-users',
    component: ServiceProviderUsersList,
    meta: {
      login: true,
      title: translate['pages.title.users'],
      icon: 'mdi-account-multiple-outline',
      roles: ['ROLE_SERVICE_PROVIDER'],
    }
  },

  {
    path: '/realties',
    name: 'serviceProviderRealties',
    component: RealtyList,
    meta: {
      login: true,
      title: translate['pages.title.realtyList'],
      icon: 'mdi-home-city-outline',
      roles: ['ROLE_SERVICE_PROVIDER'],
    },
  },

  {
    path: '/service-provider-clients',
    name: 'service-provider-clients',
    component: ServiceProviderClientsList,
    meta: {
      login: true,
      title: translate['pages.title.clients'],
      icon: 'mdi-account-group-outline',
      roles: ['ROLE_SERVICE_PROVIDER'],
    },
  },
]

export { serviceRoute }
